import { GUARDADA, OOOH, ruidosDelAcierto } from "./sonidosDelRepaso.mjs";
import { ruido } from "./sonidosDelMundo.js";

/**
 * vocesDelRepaso — las tres respuestas del repaso, tocadas. Los números, en
 * `lib/sonidosDelRepaso.mjs`; aquí sólo está qué hace sonar cada una.
 *
 * POR QUÉ ESTÁ APARTE, y lo trajo el trinquete el 14 de octubre de 2026: `lib/sound.js` estaba
 * clavado en sus cuatrocientas líneas y el acierto del repaso necesitaba explicarse. La casa
 * manda partir antes que subir el número, y éstas son las que mejor salen: **las únicas tres de
 * la caja que ya tenían su fichero de números**, así que la mudanza las deja al lado de él.
 *
 * Y RECIBEN LA CAJA ENTERA en vez de un contexto de audio: la caja es quien sabe si el canal
 * está encendido y si hay un fichero mejor que sintetizar —`_suena`—, y esa decisión no se
 * duplica aquí. Si se le pasara sólo el contexto, estas tres sonarían con los canales apagados.
 */

/**
 * EL ACIERTO DEL REPASO. Se llamaba `palmas` hasta el 14 de octubre de 2026, cuando Gabri
 * eligió para él una palmada de verdad —una sola, sin repetición— y al oírla dijo lo que hacía
 * falta oír: *«no es un sonido de palmas como tal, es otro sonido de acierto»*. Tenía razón: una
 * palmada suelta no se lee como aplauso. La clave pasa a decir lo que es.
 *
 * Y SUENA SOLO, que es el otro medio arreglo. Hasta hoy el repaso disparaba `acierto()` y encima
 * las palmas: dos sonidos de acertar amontonados, que es la mitad de por qué sonaba mal.
 *
 * Y LO SINTETIZADO ES EL RESPALDO, para quien no pueda cargar el fichero. Eran tres golpes
 * graves seguidos y no se parecían al fichero en nada: Gabri los oyó como *«dos sonidos de
 * victoria distintos»*. Ahora es **uno**, medido contra el fichero. El porqué y los números,
 * en `sonidosDelRepaso.mjs`.
 */
export function repasada(caja) {
  if (caja._suena("repasada")) ruidosDelAcierto().forEach((c) => ruido(caja._ensure(), c));
}

/** El «oooh» al fallar: tres voces que caen una tercera, desafinadas entre sí. */
export function oooh(caja) {
  if (caja._suena("oooh")) OOOH.forEach((n) => caja._tone(n));
}

/** Y la tarjeta que se guarda: un roce corto y seco. No celebra nada, y es a propósito. */
export function guardada(caja) {
  if (caja._suena("guardada")) GUARDADA.forEach((g) => ruido(caja._ensure(), g));
}
